import '../App.css';
import Bracket from './Bracket';
import ToggleButton from './ToggleButton';

function Interactive() {
  return (
    <div className="Interactive">
          <ToggleButton />
          <Bracket />
    </div>
  );
}

export default Interactive;
